import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

interface AiStatisticsSummaryViewModel {
  totalRequests: number;
  successfulRequests: number;
  failedRequests: number;
  totalTokens: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  estimatedCost: number;
  averageLatencyMs: number;
  successRate: number;
}

@Component({
  selector: 'app-ai-statistics-summary',
  templateUrl: './ai-statistics-summary.component.html',
  styleUrls: ['./ai-statistics-summary.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiStatisticsSummaryComponent {

  @Input() summary: AiStatisticsSummaryViewModel;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/ai-statistics-summary/ai-statistics-summary.component.ts